import React from 'react';
import classNames from 'classnames';
import cx from './index.module.scss';

const SearchButton = ({onSearch, isSmall = false}) => {
  return (
    <button className={classNames(cx.buttonSearch, {
      [cx.isSmall]: isSmall,
    })} type="button" onClick={onSearch}>
      <div className={cx.buttonText}>우리 회사 이름을 검색해보세요!</div>
      <div className={cx.iconWrap}>
        <img className={cx.iconSearch} src={`${process.env.PUBLIC_URL}/images/icon_search.svg`} alt=""/>
      </div>
    </button>
  )
};

export default SearchButton
